module.exports = __webpack_public_path__ + "img/lb-right-card.79b50341.svg";